// TODO: unused, remove?
// eslint-disable-next-line no-redeclare,no-unused-vars
function getRow(row, key, param) {
    var value;
    if (param.objectSub) value = row[key + ucfirst(param.objectSub)];
    if (!value) value = row[key];
    return value;
}

//# sourceMappingURL=index.2064fb2f.js.map
